import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import * as globals from "app/resources/globals";

type Entity = models.SaldosUsuariosZEViewDTO;
const resource = resources.SaldosUsuariosZE;
interface Props {
    idUsuarioZE: number | null;
    session: models.Session;
    value: Entity;
}

interface State {
    idUsuarioZE: number | null;
}

class SaldosUsuariosZENoRX extends React.PureComponent<Props, State> {
    modalManager = kea.createModalManager();

    constructor(props) {
        super(props);
        this.state = { idUsuarioZE: null };
    }

    value = (props: Props) => props.value;

    onRegresar = () => history.go('../');
    private idUsuarioZE = (props: Props) => this.props.session.IdUsuarioZE === undefined || this.props.session.IdUsuarioZE == null? null : this.props.session.IdUsuarioZE


    private saldoUsuario = createSelectorRx(this.idUsuarioZE, idUsuarioZE => {
        const obs = idUsuarioZE ? observeResource(resource.ObtenerSaldoUsuario, idUsuarioZE) : 0;
        return obs;
    });

    render() {
        const EsProveedor = this.props.session.IdUsuarioZE != null && this.props.session.IdChoferZE == null
        const EsChofer = this.props.session.IdUsuarioZE != null && this.props.session.IdChoferZE != null

        const saldoUsuario = this.saldoUsuario(this.props);
        const idUsuarioZE = this.idUsuarioZE(this.props);
        
        return (
            <div>
                <kea.Title titulo="Saldo proveedor ZE" onRegresar={this.onRegresar} />
                {kea.autogrid(12, [
                    <selectores.UsuarioZE value={idUsuarioZE} readonly={EsProveedor || EsChofer} label="Usuario de zona extendida:" />
                ])}
                <br />
                {kea.autogrid(6, [
                    <kea.Number label="Saldo actual proveedor ZE" value={saldoUsuario} format="currency" readonly />
                ])}
            </div>
        )
    }
}
const SaldosUsuariosZERX = componentToRx(SaldosUsuariosZENoRX);

export class SaldosUsuarioZE extends React.PureComponent {
    render() {
        return (
            <SaldosUsuariosZERX session={ resources.User.SessionRx }
            />
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/actividadesusuariosze/saldousuarioze/saldousuarioze.tsx